import * as React from "react";
import { FormDataConsumer, useRecordContext } from "react-admin";
import PolygonMap from "./PolygonMap";
import { useFormContext } from "react-hook-form";
import { pathsAreEqual } from "../../utils/LocationUtils";

const getPolygonCenter = (path) => {
  let latSum = 0;
  let lngSum = 0;
  path.forEach((point) => {
    latSum += point.lat;
    lngSum += point.lng;
  });
  const latCenter = latSum / path.length;
  const lngCenter = lngSum / path.length;
  return [lngCenter, latCenter];
};

const PolygonMapField = ({ creating }) => {
  const record = useRecordContext();
  // we store the path in the different order than the one we get from the map
  const initialPath = record?.points?.coordinates?.[0]?.map(([lng, lat]) => ({
    lat,
    lng,
  }));

  const { setValue } = useFormContext();

  const handlePathChange = (newPath) => {
    if (!pathsAreEqual(initialPath, newPath)) {
      setValue("centroid", getPolygonCenter(newPath), { shouldDirty: true });
      const points = newPath.length > 0 ? [...newPath, newPath[0]] : [];
      setValue("points", points, { shouldDirty: true });
    }
  };

  return (
    <FormDataConsumer>
      {({ formData }) => {
        const path = formData?.points?.coordinates
          ? formData.points.coordinates[0].map(([lng, lat]) => ({
              lat,
              lng,
            }))
          : formData?.points || [];

        const centroid =
          formData?.centroid && formData?.centroid[0]
            ? { lng: formData?.centroid[0], lat: formData?.centroid[1] }
            : undefined;

        return (
          <PolygonMap
            initialPath={path}
            centroid={centroid}
            onPathChange={handlePathChange}
            creating={creating}
          />
        );
      }}
    </FormDataConsumer>
  );
};

export default PolygonMapField;
